import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    coinList: [],
    updatePosterDialog: false,
    ctflist: []
  },
  getters: {},
  mutations: {
    setctflist(state, payload) {
      state.ctflist = payload;
    },
    setupdatePosterDialog(state, payload) {
      state.updatePosterDialog = payload;
    },
    setCoinList(state, payload) {
      state.coinList = payload;
    }
  },
  actions: {
    createLCtf(context, data) {
      return api.createLCtf(data);
    },
    listAllCoin({ commit }) {
      api.getAllCoin().then(({ data }) => {
        commit('setCoinList', data);
      });
    },
    getCtflist({ commit }, data) {
      api.getList(data).then(({ data }) => {
        commit('setctflist', data);
      });
    },
    delOne({commit},type){
     return api.delOne(type).then(res=>{
        return res
      })
    }
  }
};

appStore.registerModule('ctf', store);
